import { Logo as WiseLogo, LogoType } from '@transferwise/components';
import React from 'react';
import Types from 'prop-types';
import { Locale, LocaleValues, SupportedHomeLocales } from '../../common/l10n';
var MobileLogo = function MobileLogo(_ref) {
  var locale = _ref.locale,
    inverse = _ref.inverse;
  var logoLink = "/".concat(Object.values(SupportedHomeLocales).includes(locale) ? locale : '');
  return /*#__PURE__*/React.createElement("a", {
    className: "footer-mobile-logo m-b-4 hidden-md hidden-lg hidden-xl",
    href: logoLink
  }, /*#__PURE__*/React.createElement(WiseLogo, {
    inverse: inverse,
    type: LogoType.WISE
  }));
};
MobileLogo.defaultProps = {
  locale: Locale.GB,
  inverse: false
};
export default MobileLogo;